if (!customElements.get('vault-studio')) {
  customElements.define('vault-studio', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const viewport = this.querySelector('[data-viewport]');
      const arrows = this.querySelector('[data-arrows]');
      if (!viewport) return;
      let startX = 0, startScroll = 0, dragging = false, moved = false;
      const update = () => { arrows.hidden = viewport.scrollWidth <= viewport.clientWidth + 1; };
      this.observer = new ResizeObserver(update);
      this.observer.observe(viewport);
      viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
      this.querySelectorAll('[data-pan]').forEach(button => button.addEventListener('click', () => {
        viewport.scrollBy({ left: Number(button.dataset.pan) * viewport.clientWidth * .65, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      viewport.addEventListener('pointerdown', event => {
        if (event.target.closest('video, iframe, button, input')) return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true; moved = false; startX = event.clientX; startScroll = viewport.scrollLeft;
      }, options);
      window.addEventListener('pointermove', event => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 6) { moved = true; viewport.classList.add('is-dragging'); }
        if (moved) { event.preventDefault(); viewport.scrollLeft = startScroll - distance; }
      }, options);
      const stop = () => { dragging = false; viewport.classList.remove('is-dragging'); };
      window.addEventListener('pointerup', stop, options);
      window.addEventListener('pointercancel', stop, options);
      viewport.addEventListener('dragstart', event => event.preventDefault(), options);
      viewport.addEventListener('click', event => { if (moved) { event.preventDefault(); moved = false; } }, { ...options, capture: true });
      viewport.addEventListener('keydown', event => {
        if (event.target !== viewport || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); viewport.scrollLeft += event.key === 'ArrowRight' ? 150 : -150;
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const hotspot = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (hotspot) viewport.scrollLeft = hotspot.offsetLeft - viewport.clientWidth / 2;
      }, options);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
